<template>
  <div class="stockholder-frame">
    <a class="anchor" id="dotJzygd"></a>
    <div class="home-title-bt">
      <div class="home-t-bg">Core Shareholders</div>
      <p>主要股东</p>
    </div>
    <div class="stockholder-main">
      <div class="stockholder-item" style="padding-bottom: 178px">
        <img
          class="item-icon animated wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".2s"
          src="../../../assets/images/icon/mhlogo.png"
          alt=""
        />
        <div class="stockholder-txt">
          <div
            class="txt-title animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".2s"
          >
          上海市闵行资产投资经营 (集团) 有限公司
          </div>
          <div
            class="txt-title animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".2s"
            style="font-size: 16px"
          >
            国资大股东
          </div>
          <div
            class="txt-main animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".3s"
          >
          强大后盾：闵资集团战略入股<br/>
百昌科技集团大股东为闵行区政府直属国企 — 上海市闵行资产投资经营（集团）有限公司（简称 “闵资集团”）。其经营策略和风险控制机制为百昌科技集团提供了宝贵的借鉴和示范。<br/><br/>

严格监管：国资平台合规保障<br/>
闵资集团对百昌科技集团的经营活动进行了严格的监管与指导。从规范化、制度化入手，助力构建合规体系，保障客户交易流程安全及科技产品数据合规，为企业的稳健发展提供了有力支撑。

          </div>
        </div>
      </div>
      <div
        class="stockholder-item animated wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay=".2s"
      >
        <img
          class="item-js animated wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay=".2s"
          src="../../../assets/images/join/gd-img.png"
          alt=""
        />
        <div class="stockholder-txt" style="width: 687px;padding-left: 450px">
          <div
            class="txt-title animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".2s"
          >
            曾鸣教授
          </div>
          <div
            class="txt-title animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".2s"
            style="font-size: 16px"
          >
            商业领袖认可
          </div>
          <div
            class="txt-main animated wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay=".3s"
          >
            曾经担任阿里巴巴集团总参谋长，在此之前任教于长江商学院和INSEAD。作为战略学专家，曾博士对于战略创新、战略转型、战略联盟与并购、电子商务以及国际化战略等方面的深入研究――均被《Academy
            of Management Review》、《Organization
            Science》等世界顶尖管理杂志认可和发表，并被《华尔街日报》、《经济学人》、CNBC和BBC等媒体广泛报道。曾博士多年来致力于中国企业的发展研究。他与处于领导地位的中国企业包括海尔、联想等一直保持紧密的合作关系。曾博士2003年在《Harvard
            Business
            Review》发表的关于中国企业国际竞争力的文章在全球产生了巨大的影响，是今年来哈佛商业评论被引用最多的文章之一。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stockholder",
  mounted() {
    this.$nextTick(() => {
      let wow = new this.$wow.WOW({
        offset: 100,
      });
      wow.init();
    });
  },
};
</script>

<style scoped lang="scss">
.stockholder-frame {
  position: relative;
  .anchor {
    position: absolute;
    opacity: 0;
    top: -200px;
  }
  .stockholder-main {
    padding-top: 70px;
    padding-bottom: 200px;
    .stockholder-item {
      position: relative;
      .stockholder-txt {
        width: 772px;
        padding-left: 56px;
        font-family: "SourceHanSansCN-Regular";
        .txt-title {
          font-size: 24px;
          font-weight: bold;
          color: #333333;
          line-height: 30px;
          padding-bottom: 10px;
        }
        .txt-main {
          font-size: 14px;
          color: #333333;
          line-height: 30px;
        }
      }
      .item-icon {
        position: absolute;
        display: block;
        width: 214px;
        height: 222px;
        top: 30px;
        right: 70px;
      }
      .item-js {
        position: absolute;
        display: block;
        width: 491px;
        height: 403px;
        top: -123px;
        left: -90px;
      }
    }
  }
}
</style>
